import { yupResolver } from '@hookform/resolvers/yup'
import { DateOnly } from '@if/core/date'
import { dateOnly, number, object } from '@if/core/yup'
import { useMemo } from 'react'
import { Resolver } from 'react-hook-form'

export interface BatchUpdatePaymentsSchemaType {
  amount: number
  amountToCatchUp?: number
  fromPaymentDate?: DateOnly | null
}

const batchUpdatePaymentsSchema = object({
  amount: number().required(),
  fromPaymentDate: dateOnly().nullable().optional(),
})

export const useBatchUpdatePaymentsSchema = (initialAmount?: number) => {
  return useMemo<{
    resolver: Resolver<BatchUpdatePaymentsSchemaType>
    defaultValues: BatchUpdatePaymentsSchemaType
  }>(() => {
    return {
      resolver: yupResolver(batchUpdatePaymentsSchema),
      defaultValues: {
        amount: initialAmount ?? 0,
        fromPaymentDate: null,
      },
    }
  }, [initialAmount])
}
